import { render } from "./AddStrandsDataTable.vue?vue&type=template&id=8679e446"
import script from "./AddStrandsDataTable.vue?vue&type=script&lang=js"
export * from "./AddStrandsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__